(() => {
    const CONFIG = {
        ROOT_SELECTOR: '[id^="hulkapps_custom_options_"]',
        INPUT_SELECTOR:
            '.hulkapps_option_set .hulkapps_option.custom-length input[type="number"]',
        PRICE_SELECTOR: '[data-hulk-custom-price]',
        OUTPUT_SELECTOR:
            '.hulkapps_option.simple-formula input.hulkapps_option_child',
        INIT_TIMEOUT_MS: 15000
    };

    let isBound = false;

    /* ---------------- INIT ---------------- */

    function init() {
        console.log('Init hulk custom price');
        if (isBound) return;
        isBound = true;

        document.addEventListener('change', handleLengthChange, true);
    }

    /* ---------------- EVENT HANDLER ---------------- */

    function handleLengthChange(event) {
        console.log("Change event triggered: ", event.target);
        const input = event.target.closest(CONFIG.INPUT_SELECTOR);
        if (!input) return;

        if (!input.closest(CONFIG.ROOT_SELECTOR)) return;
        console.log(CONFIG.ROOT_SELECTOR, 'Root Selector');
        console.log(input.closest(CONFIG.ROOT_SELECTOR), 'Closest selector is this');

        const length = parseFloat(input.value);
        console.log('Length: ', length);
        if (!Number.isFinite(length) || length <= 0) return;

        const outputEl = document.querySelector(CONFIG.OUTPUT_SELECTOR);
        console.log('Output Element: ', outputEl);
        if (!outputEl) return;

        const totalPrice = resolvePricing(length);
        console.log(resolvePricing(totalPrice));
        if (!totalPrice) return;
        console.log("Total Price: ", totalPrice);

        outputEl.value = totalPrice;
        outputEl.dispatchEvent(new Event('change', { bubbles: true }));
    }

    function resolvePricing(length) {
        return calculateSimplePrice(length);
    }

    function calculateSimplePrice(length) {
        const priceEl =
            document.querySelector(CONFIG.PRICE_SELECTOR) ||
            document.querySelector('.price-item.price-item-regular');

        const pricePerMeter = parseFloat(priceEl?.dataset?.hulkCustomPrice);
        console.log('Price per meter: ', pricePerMeter);
        if (!Number.isFinite(pricePerMeter)) return null;

        const total = (pricePerMeter / 100) * length / 100;
        return total.toFixed(2);
    }

    // function calculateCompoundPrice(length) {
    //     const bundle = window.hulkBundleMap;
    //     console.log(bundle,' Is bundle');
    //     if (!bundle) return null;

    //     const ports = getChosenPorts();
    //     console.log('Ports: ', getChosenPorts());
    //     if (ports.length < 2) return null;

    //     const meterPrice = (bundle.pricePerMeter / 100) * length;

    //     const breakdown = {
    //         'Preis Rollenware': meterPrice,
    //         'Basispreis': bundle.basePrice,
    //         'Anschluss 1': ports[0].price,
    //         'Anschluss 2': ports[1].price
    //     };

    //     const totalCents = meterPrice + bundle.basePrice;

    //     return {
    //         total: (totalCents / 100).toFixed(2),
    //         breakdown
    //     };
    // }

    /* ---------------- PORTS ---------------- */

    // function getChosenPorts() {
    //     return Array.from(
    //         document.querySelectorAll(
    //             'input[name^="Anschluss 1" i]:checked, input[name^="Anschluss 2" i]:checked'
    //         )
    //     )
    //         .map(input => {
    //             const entry = window.hulkBundleMap.portData.find(
    //                 p => p.port_name === input.value
    //             );

    //             if (!entry || !entry.port_price?.amount) return null;

    //             return {
    //                 name: entry.port_name,
    //                 price: parseFloat(entry.port_price.amount) * 100
    //             };
    //         })
    //         .filter(Boolean);
    // }

    /* ---------------- UTILS ---------------- */

    function formatMoney(cents) {
        return window.hulkapps.money_format.replace(
            '{{amount_with_comma_separator}}',
            (cents / 100).toFixed(2).replace('.', ',')
        );
    }

    /* ---------------- BOOTSTRAP ---------------- */

    const start = Date.now();
    const observer = new MutationObserver(() => {
        if (document.querySelector(CONFIG.ROOT_SELECTOR)) {
            observer.disconnect();
            init();
        }

        if (Date.now() - start > CONFIG.INIT_TIMEOUT_MS) {
            observer.disconnect();
        }
    });

    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
})();
